export const Projects = [
  {
    id: 77,
    image: "/projects/gc.webp",
    title: "Global Clean",
    url: "https://global-clean.co.uk/",
    description:
      "Global Clean highlights our expertise in providing top-quality cleaning services across the UK. This platform showcases our commitment to delivering spotless results for homes and businesses alike. By offering eco-friendly solutions and flexible scheduling, Global Clean reflects our dedication to creating healthier and more inviting spaces. We strive to set a new standard in professional cleaning services, ensuring client satisfaction with every job.",
  },
  {
    id: 88,
    image: "/projects/dac.webp",
    title: "Dunes Auto Qatar",
    url: "https://dunesautoqatar.com/",
    description:
      "Dunes Auto Qatar is your trusted destination for buying and selling cars with ease and confidence. Our platform connects buyers and sellers, offering a seamless experience backed by transparency and reliability. Whether you're looking to purchase your dream car or sell your vehicle at the best value, Dunes Auto Qatar ensures a smooth and efficient process every step of the way. Experience a hassle-free approach to car trading with us!",
  },
  {
    id: 99,
    image: "/projects/sls.webp",
    title: "SLS",
    url: "https://sls.com.pk/",
    description:
      "SLS is your go-to solution for reliable and high-speed internet services. We specialize in delivering seamless connectivity for homes and businesses, ensuring you stay connected when it matters most. With SLS, enjoy uninterrupted browsing, streaming, and communication through our cutting-edge technology and exceptional customer support. Choose SLS for internet services that keep you ahead in today’s digital world.",
  },
  {
    id: 11,
    image: "/projects/awanllc.webp",
    title: "Awan LLC",
    url: "https://awanllc.com/",
    description:
      "Crafted an elegant and user-friendly e-commerce platform for Awan LLC using WordPress. The website features a sleek design, intuitive navigation, and robust functionality to enhance the shopping experience. Integrated seamless payment gateways and advanced product management tools. Focused on optimizing performance and ensuring responsive design for all devices. This project showcases my expertise in creating professional, high-converting online stores.",
  },
  {
    id: 22,
    image: "/projects/partydjs.webp",
    title: "Party DJS dubai",
    url: "https://partydjsdubai.com/",
    description:
      "Developed a dynamic and visually engaging website for Part DJS Dubai, a premier DJ system company, using WordPress. The site highlights their top-tier services with immersive multimedia features, sleek design, and intuitive navigation. Implemented advanced booking and contact functionalities, ensuring a seamless user experience. Optimized for performance and mobile responsiveness, this project reflects my ability to create captivating and functional websites for the entertainment industry.",
  },
  {
    id: 33,
    image: "/projects/beyondsports.webp",
    title: "Beyond sports",
    url: "https://beyondsports.live/",
    description:
      "Engineered a cutting-edge sports data website, Beyond Sports, for a Qatar-based client using React, Tailwind CSS, and Supabase. The platform features real-time sports data visualization, sleek and responsive design, and user-friendly navigation. Integrated advanced data management and analytics tools to provide in-depth insights and enhance user engagement. This project demonstrates my expertise in modern web technologies and my ability to deliver high-performance solutions.",
  },
  {
    id: 44,
    image: "/projects/sallanchem.webp",
    title: "Sallan Industrial Investment",
    url: "https://sallanchem-gulf.com/",
    description:
      "Designed and developed a comprehensive website for Sallan Industrial Investment LLC to showcase their extensive range of products. Utilizing WordPress, the site features a clean and professional layout, detailed product pages, and an intuitive user interface. Enhanced with multimedia elements and optimized for both performance and responsiveness, this project highlights my ability to create impactful digital experiences that effectively present company offerings.",
  },
  {
    id: 55,
    image: "/projects/fc.webp",
    title: "Future Consultants.",
    url: "https://www.futureconsultants.co.uk/",
    description:
      "Future Consultants showcases my expertise in creating user-friendly and visually appealing websites that effectively communicate services. Through a blend of modern design and strategic functionality, I developed this site to highlight my consultancy offerings. My attention to detail and commitment to responsive design ensure that visitors have an engaging experience, reflecting my dedication to quality and professionalism in every project.",
  },
  {
    id: 66,
    image: "/projects/ixperts.webp",
    title: "Ixperts",
    url: "https://www.ixperts.biz/",
    description:
      "Ixperts exemplifies my skills in delivering comprehensive web development solutions, digital marketing strategies, and professional video editing services. This site is designed to showcase my ability to blend creativity with technical expertise, providing clients with an intuitive and engaging platform. By highlighting our diverse service offerings, I aim to demonstrate my commitment to helping businesses thrive in the digital landscape through innovative and effective solutions.",
  },
];
